import {push, replace} from 'connected-react-router';

export const routeState__push = to =>
	async dispatch => dispatch(push(to));
export const routeState__redirect = to =>
	async dispatch => dispatch(replace(to));

export const routeState__noAccess = () => routeState__redirect('/no-access');
export const routeState__notFound = () => routeState__redirect('/not-found');